import { handleWallpaperColorPost } from "../api/settings/wallpaper";
import { WALLPAPER_COLOR_CODES } from "../Helpers/Constants";
import { RESET_WALLPAPER_COLOR, SET_WALLPAPER_COLOR, SET_WALLPAPER_PREVIEW_COLOR, WALLPAPER_PREVIEW_SECTION } from "./Constants";

/**
 * Show wallpaper preview section
 * @param {boolean} previewSection - The color code to set
 */
export const wallpaperPreviewSection = (previewSection) => {
  
  return {
    type: WALLPAPER_PREVIEW_SECTION,
    payload: {
      previewSection,
    }
  };
};

/**
 * Action to set wallpaper preview color
 * @param {string} previewColor - The color code to set
 */
export const setWallpaperPreviewColor = (previewColor) => {
  
  return {
    type: SET_WALLPAPER_PREVIEW_COLOR,
    payload: {
      previewColor,
    }
  };
};

/**
 * Action to set wallpaper color
 * @param {string} color - The color code to set
 */
export const setWallpaperColor = (color) => {
  
  return async (dispatch, getState) => {
    try {
      const colorToUse = color || WALLPAPER_COLOR_CODES[0];
      // Make API call
      await handleWallpaperColorPost(colorToUse);

      // Update Redux state first (optimistic update)
      dispatch({
        type: SET_WALLPAPER_COLOR,
        payload: { color: colorToUse}
      });  
    } catch (error) {
      console.error('Failed to set wallpaper color:', error);
    }
  };
};

/**
 * Action to reset wallpaper to default (transparent)
 */
export const resetWallpaperColor = () => {

  return async (dispatch, getState) => {
    try {
      const colorToUse = WALLPAPER_COLOR_CODES[0];
      
      // Make API call
      await handleWallpaperColorPost(colorToUse);

      // Update Redux state first
      dispatch({
        type: RESET_WALLPAPER_COLOR,
        payload: { color: colorToUse}
      });
      
    } catch (error) {
      console.error('Failed to reset wallpaper color:', error);
    }
  };
};

/**
 * Action to initialize wallpaper color from localStorage
 */
export const initializeWallpaperColor = (color) => {
    return async (dispatch, getState) => {
    try {
      const colorToUse = color || WALLPAPER_COLOR_CODES[0];

      // Update Redux state
      dispatch({
        type: SET_WALLPAPER_COLOR,
        payload: { color: colorToUse}
      });
      
      
    } catch (error) {
      console.error('Failed to initialize wallpaper color:', error);
    }
  };
};
